module.exports = {
  'en': {
    'LOV_COMP': {
      '0': 'List Of Company Name',
      '1': 'List Of Company Name',
      '2': 'Code of Company',
      '3': 'Name of Company'
    },
    'LOV_EMP': {
      '0': 'List of All Employee',
      '1': 'List of All Employee',
      '2': 'Employee Code',
      '3': 'Employee Name',
      '4': 'Status of Emp.',
      '5': 'Security'
    },
    'LOV_POS': {
      '0': 'List of Position Code',
      '1': 'List of Position Code',
      '2': 'Position Code',
      '3': 'Description'
    },
    'LOV_CODAPP': {
      '0': 'List of Appl. Name',
      '1': 'List of Appl. Name',
      '2': 'Code Appl. Name',
      '3': 'Description'
    },
    'LOV_MEMO': {
      '0': 'List Of Memo No.',
      '1': 'Memo No.',
      '2': 'Year',
      '3': 'Month',
      '4': 'Class',
      '5': 'Course',
      '6': 'Description'
    },
    'LOV_CORS': {
      '1': 'List of Course Training Code',
      '2': 'Course Code',
      '3': 'Course Name'
    },
    'LOV_FORM': {
      '0': 'List of Appraisal Form',
      '1': 'List of Appraisal Form',
      '2': 'App. Form No.',
      '3': 'Description'
    },
    'LOV_APP3': {
      '0': 'List of All Application No.',
      '1': 'List of All Application No.',
      '2': 'Applicant No.',
      '3': 'Appl Name.',
      '4': 'Status'
    },
    'LOV_APLV': {
      '0': 'Type of Appraisal group',
      '1': 'Type of Appraisal group',
      '2': 'Type of Appraisal group',
      '3': 'Description'
    },
    'LOV_NUMREQ': {
      '0': 'List of Personnal Request',
      '1': 'List of Personnal Request',
      '2': 'Request No',
      '3': 'Department Req.',
      '4': 'Position Req.',
      '5': 'Description'
    },
    'LOV_CODAPPR': {
      '0': 'List of All Employee',
      '1': 'List of All Employee',
      '2': 'Employee Code',
      '3': 'Employee Name',
      '4': 'Status of Emp.',
      '5': 'Security'
    },
    'LOV_SHIF': {
      '0': 'List of Shift Code',
      '1': 'List of Shift Code',
      '2': 'Shift Code',
      '3': 'Description',
      '4': 'Schedule Time'
    },
    'LOV_ROOM': {
      '0': 'List of Room Number',
      '1': 'List of Room Number',
      '2': 'Room Number',
      '3': 'Room Name'
    },
    'LOV_ASSET': {
      '0': 'List of Company Asset Code',
      '1': 'List of Company Asset Code',
      '2': 'Company Asset Code',
      '3': 'Description'
    },
    'LOV_WORK': {
      '0': 'List of Work Group Code',
      '1': 'List of Work Group Code',
      '2': 'Work Group Code',
      '3': 'Description'
    },
    'HRAP31EC6': {
      '250': '',
      '260': '',
      '270': ''
    },
    'LOV_BATCH': {
      '0': 'List of Batch No',
      '1': 'List of Batch No',
      '2': 'Batch No',
      '3': 'Entrydate',
      '4': 'Lastseq'
    },
    'LOV_COSTCENT': {
      '0': 'List of Cost Center',
      '1': 'List of Cost Center',
      '2': 'Cost Center Code',
      '3': 'Description'
    },
    'LOV_LOCA': {
      '0': 'Work Location Code',
      '1': 'Work Location Code',
      '2': 'Code of Location',
      '3': 'Description'
    },
    'LOV_TNCY': {
      '0': 'Type of Special Skills/Exp.',
      '1': 'Type of Special Skills/Exp.',
      '2': 'Code of Special Skills/Exp.',
      '3': 'Description'
    },
    'LOV_EDUC': {
      '0': 'List of Education Code',
      '1': 'List of Education Code',
      '2': 'Education Code',
      '3': 'Description'
    },
    'LOV_JOB': {
      '0': 'List Of job description',
      '1': 'List Of job description',
      '2': 'job description Code',
      '3': 'Description'
    },
    'LOV_EMPL': {
      '0': 'List Of Employment Type',
      '1': 'List Of Employment Type',
      '2': 'Employment Type Code',
      '3': 'Description'
    },
    'LOV_CATG': {
      '0': 'List Of Employee Type',
      '1': 'List Of Employee Type',
      '2': 'Employee Type Code',
      '3': 'Description'
    },
    'LOV_TYPY': {
      '0': 'List of Payroll Group',
      '1': 'List of Payroll Group',
      '2': 'Code',
      '3': 'Description'
    },
    'LOV_INST': {
      '0': 'Institute Code',
      '1': 'Institute Code',
      '2': 'Institute Code',
      '3': 'Description'
    },
    'LOV_STAEMP': {
      '0': 'List of Employee status',
      '1': 'List of Employee status',
      '2': 'Code',
      '3': 'Description'
    },
    'LOV_PROV': {
      '0': 'Province Code',
      '1': 'Province Code',
      '2': 'Province Code',
      '3': 'Description'
    }
  },
  'th': {
    'LOV_COMP': {
      '0': 'รายชื่อบริษัท',
      '1': 'รายชื่อบริษัท',
      '2': 'รหัสบริษัท',
      '3': 'ชือบริษัท'
    },
    'LOV_EMP': {
      '0': 'รายชื่อพนักงานทั้งหมด',
      '1': 'รายชื่อพนักงานทั้งหมด',
      '2': 'รหัสพนักงาน',
      '3': 'ชื่อ - นามสกุล',
      '4': 'สถานะพนักงาน',
      '5': 'Security'
    },
    'LOV_POS': {
      '0': 'รายชื่อตำแหน่งงาน',
      '1': 'รายชื่อตำแหน่งงาน',
      '2': 'รหัสตำแหน่ง',
      '3': 'รายละเอียด'
    },
    'LOV_CODAPP': {
      '0': 'รายชื่อของโปรแกรม',
      '1': 'รายชื่อของโปรแกรม',
      '2': 'รหัสโปรแกรม',
      '3': 'รายละเอียด'
    },
    'LOV_MEMO': {
      '0': 'รายการรหัส Memo',
      '1': 'รหัส Memo',
      '2': 'ปี',
      '3': 'เดือน',
      '4': 'รุ่น',
      '5': 'หลักสูตร',
      '6': 'รายละเอียด'
    },
    'LOV_CORS': {
      '1': 'รายชื่อหลักสูตรการอบรมพนักงาน',
      '2': 'รหัสหลักสูตร',
      '3': 'ชื่อหลักสูตร'
    },
    'LOV_FORM': {
      '0': 'รายการเลชที่แบบฟอร์มประมเินผล',
      '1': 'รายการเลชที่แบบฟอร์มประมเินผล',
      '2': 'เลขที่แบบฟอร์ม',
      '3': 'รายละเอียด'
    },
    'LOV_APP3': {
      '0': 'รายชื่อเลขที่ใบสมัคร',
      '1': 'รายการเลขที่ใบสมัคร',
      '2': 'เลขที่ใบสมัคร',
      '3': 'ชื่อผู้สมัคร',
      '4': 'สถานะ'
    },
    'LOV_APLV': {
      '0': 'รายชื่อประเภทกลุ่มการประเมิน',
      '1': 'รายชื่อประเภทกลุ่มการประเมิน',
      '2': 'ประเภทกลุ่มการประเมิน',
      '3': 'รายละเอียด'
    },
    'LOV_NUMREQ': {
      '0': 'รายการเลขที่ใบขออนุมัติจ้างงาน',
      '1': 'รายการเลขที่ใบขออนุมัติจ้างงาน',
      '2': 'เลขที่ใบขออนุมัติ',
      '3': 'หน่วยงานที่ขอ',
      '4': 'ตำแหน่งที่ขอ',
      '5': 'รายละเอียด'
    },
    'LOV_CODAPPR': {
      '0': 'รายชื่อพนักงานทั้งหมด',
      '1': 'รายชื่อพนักงานทั้งหมด',
      '2': 'รหัสพนักงาน',
      '3': 'ชื่อ - นามสกุล',
      '4': 'สถานะพนักงาน',
      '5': 'Security'
    },
    'LOV_SHIF': {
      '0': 'รายการรหัสกะ',
      '1': 'รายการรหัสกะ',
      '2': 'รหัสกะ',
      '3': 'รายละเอียด',
      '4': 'ตารางเวลา'
    },
    'LOV_ROOM': {
      '0': 'รายการห้องประชุม',
      '1': 'รายการห้องประชุม',
      '2': 'เลขที่ห้อง',
      '3': 'ชื่อห้อง'
    },
    'LOV_ASSET': {
      '0': 'รายการรหัสทรัพย์สินของบริษัท',
      '1': 'รายการรหัสทรัพย์สินของบริษัท',
      '2': 'รหัสทรัพย์สินของบริษัท',
      '3': 'รายละเอียด'
    },
    'LOV_WORK': {
      '0': 'รายการรหัสกลุ่มการทำงาน',
      '1': 'รายการรหัสกลุ่มการทำงาน',
      '2': 'รหัสกลุ่มการทำงาน',
      '3': 'รายละเอียด'
    },
    'HRAP31EC6': {
      '250': '',
      '260': '',
      '270': ''
    },
    'LOV_BATCH': {
      '0': 'รายการ Batch No',
      '1': 'รายการ Batch No',
      '2': 'Batch No',
      '3': 'วันที่บันทึก',
      '4': 'จำนวนข้อมูล'
    },
    'LOV_COSTCENT': {
      '0': 'รายชื่อรหัส Cost Center',
      '1': 'รายชื่อรหัส Cost Center',
      '2': 'รหัส',
      '3': 'รายละเอียด'
    },
    'LOV_LOCA': {
      '0': 'รหัสสถานที่',
      '1': 'รหัสสถานที่',
      '2': 'รหัส',
      '3': 'รายละเอียด'
    },
    'LOV_TNCY': {
      '0': 'รหัสความสามารถ',
      '1': 'รหัสความสามารถ',
      '2': 'รหัสความสามารถ',
      '3': 'รายละเอียด'
    },
    'LOV_EDUC': {
      '0': 'รายการรหัสการศึกษา',
      '1': 'รายการรหัสการศึกษา',
      '2': 'รหัสการศึกษา',
      '3': 'รายละเอียด'
    },
    'LOV_JOB': {
      '0': 'รายการรหัสลักษณะงาน',
      '1': 'รายการรหัสลักษณะงาน',
      '2': 'รหัสลักษณะงาน',
      '3': 'รายละเอียด'
    },
    'LOV_EMPL': {
      '0': 'รายการประเภทการจ้างงาน',
      '1': 'รายการประเภทการจ้างงาน',
      '2': 'รหัสประเภทการจ้างงาน',
      '3': 'รายละเอียด'
    },
    'LOV_CATG': {
      '0': 'รายการประเภทพนักงาน',
      '1': 'รายการประเภทพนักงาน',
      '2': 'รหัสประเภทพนักงาน',
      '3': 'รายละเอียด'
    },
    'LOV_TYPY': {
      '0': 'รายการกลุ่มการจ่ายเงินเดือน',
      '1': 'รายการกลุ่มการจ่ายเงินเดือน',
      '2': 'รหัส',
      '3': 'รายละเอียด'
    },
    'LOV_INST': {
      '0': 'รหัสสถาบัน',
      '1': 'รหัสสถาบัน',
      '2': 'รหัส',
      '3': 'รายละเอียด'
    },
    'LOV_STAEMP': {
      '0': 'รายการสถานะพนักงาน',
      '1': 'รายการสถานะพนักงาน',
      '2': 'รหัส',
      '3': 'รายละเอียด'
    },
    'LOV_PROV': {
      '0': 'รายชื่อรหัสจังหวัด',
      '1': 'รายชื่อรหัสจังหวัด',
      '2': 'รหัส',
      '3': 'รายละเอียด'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hrmsLov.js